import axios from 'axios';
import { store } from '@/store';
import router from '@/router/index';

const axiosWithCookies = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_BASE_PATH
});
export const getController = async ({ url = '', params, headers } = {}) => {
  try {
    const response = await axiosWithCookies.get(url, {
      params,
      headers
    });
    return response;
  } catch (error) {
    console.error(error);
    if (router.app._route.meta.auth) {
      if (error.response.status === 401) {
        store.commit('auth/removeAuth');
        if (error.response.data.code === 'SESSION_LOST') {
          store.commit('auth/setIsSessionLost', true);
        }
        router.push(`/login?return={${window.location.pathname}}`);
      } else if (error.response.status === 403) {
        return error.response;
      }
    }
  }
};

export const postController = ({ url = '', options, params = {} } = {}) => {
  try {
    const response = axiosWithCookies.post(url, options, params);
    return response;
  } catch (error) {
    if (error.response.status === 403) {
      return error.response.data;
    } else console.error(error);
  }
};
